import './index.css';

export default {
  name: 'Atypewriter',
  props: {
    id: { type: String, default: () => (`a-typewriter-${Math.random().toString().substring(2)}`) },
    speed: { type: Number | String, default: () => 10 }, // 输出速度(值越小越快)
    text: { type: String, default: () => null },
    value: { type: String, default: () => null },
    values: { type: String, default: () => null },
    content: { type: String, default: () => null },
    context: { type: String, default: () => null },
  },
  data() {
    return ({
      model: '',
      timeout: null,
    });
  },
  watch: {
    text() { this.create() },
    value() { this.create() },
    values() { this.create() },
    content() { this.create() },
    context() { this.create() },
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        this.revoke();
        this.$nextTick(() => {
          // const text = this.context || this.content || this.values || this.value || this.text || '';
          // let value = text.replace(/<[^>]*>/g, '');
          const value = this.context || this.content || this.values || this.value || this.text || '';
          let index = 0;
          const write = () => {
            if (index < value.length) {
              this.model += value[index];
              index++;
              this.cancel();
              this.$emit('input', this.model);
              const input = this.$el.querySelector('textarea');
              input.scrollTop = input.scrollHeight;
              input.setSelectionRange(value.length, value.length);
              this.$nextTick(() => this.timeout = setTimeout(write, parseInt(this.speed)));
            }
          }
          write();
        });
      });
    },
    cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    },
    revoke() {
      this.cancel();
      this.$nextTick(() => {
        this.model = '';
      });
    },
  },
  render() {
    const { padding, margin, resize = 'none', spellcheck = false, ...attrs } = this.$attrs;
    return (
      <div id={this.id} class="a-typewriter" style={{ padding, margin }}>
        <el-input
          ref="input"
          class="a-typewriter-input"
          v-model={this.model}
          type="textarea"
          resize={resize}
          spellcheck={spellcheck}
          attrs={attrs}
        />
      </div>
    );
  }
}